import 'react';
import '../../../assets/logo.module.css.mjs';
import { GithubIcon } from '../../../assets/logo-color/Github.mjs';
import { GmailIcon } from '../../../assets/logo-color/Gmail.mjs';
import { GoogleIcon } from '../../../assets/logo-color/Google.mjs';
import { HubspotIcon } from '../../../assets/logo-color/Hubspot.mjs';
import { MicrosoftIcon } from '../../../assets/logo-color/Microsoft.mjs';
import { OktaIcon } from '../../../assets/logo-color/Okta.mjs';
import { OutlookIcon } from '../../../assets/logo-color/Outlook.mjs';
import { SlackIcon } from '../../../assets/logo-color/Slack.mjs';
import { YahooIcon } from '../../../assets/logo-color/Yahoo.mjs';

const oauthIcons = {
    google: GoogleIcon,
    microsoft: MicrosoftIcon,
    hubspot: HubspotIcon,
    slack: SlackIcon,
    github: GithubIcon
};
const ssoIcons = {
    google: GoogleIcon,
    microsoft: MicrosoftIcon,
    okta: OktaIcon
};
const emailIcons = {
    gmail: GmailIcon,
    outlook: OutlookIcon,
    yahoo: YahooIcon
};

export { emailIcons, oauthIcons, ssoIcons };
//# sourceMappingURL=Icons.mjs.map
